import React from "react";
import Drawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { DrawerProps } from "../data/DrawerProps";
import "./Drawer.css";

const drawerWidth = 240;

const DrawerComponent: React.FC<DrawerProps> = ({
  open = false,
  handleDrawerClose = () => {},
  drawerTabs = [],
  handleMenuItemClick = () => {},
  renderComponent = () => {},
}) => {
  return (
    <div>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            zIndex:'1',
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <div className="drawerHeader">
          <IconButton onClick={handleDrawerClose}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider />
        {drawerTabs.map((text) => (
          <ListItem key={text} disablePadding>
            <ListItemButton onClick={() => handleMenuItemClick(text)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
        <Divider />
      </Drawer>
      <div className={`main ${open ? "mainOpen" : ""}`}>
        {renderComponent()}
      </div>
    </div>
  );
};

export default DrawerComponent;